import React from "react";
import Link from "next/link";
import Head from "next/head";
import Layout from "../../common/Layout";

export default function Error() {
  return (
    <Layout>
      <Head>
        <title>Modulabs | Contact Submission Error</title>
      </Head>
      <div className="error-area ptb--200 ptb_sm--60 ptb_md--80">
        <div className="container">
          <div className="row align-item-center">
            <div className="col-lg-12">
              <div className="error-inner">
                <h1>500</h1>
                <h2 className="title">
                  We were unable to accept your form please try again.
                </h2>
                <div className="view-more-button">
                  <Link href="/contact-us">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className="btn-default">Go Back</a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
